import { createClientEntity } from '../entities'

export class ClientEntities {
  constructor(world) {
    this.world = world
    this.byId = new Map()
  }

  has(id) {
    return this.byId.has(id)
  }

  get(id) {
    return this.byId.get(id)
  }

  values() {
    return this.byId.values()
  }

  addMany(entities) {
    for (const entity of entities) {
      this.add(entity)
    }
  }

  add(data) {
    if (this.byId.has(data.id)) return console.log('skipped adding entity (already have it)', data)
    const entity = createClientEntity(this.world, data)
    this.byId.set(entity.id, entity)
    if (data.id === this.world.playerId) {
      this.world.controller.attach(entity)
    }
    return entity
  }

  removeByChunk(chunkId) {
    for (const entity of this.byId.values()) {
      if (entity.chunkId === chunkId) {
        this.remove(entity.id)
      }
    }
  }

  remove(entityId) {
    const entity = this.byId.get(entityId)
    if (!entity) return console.log('remove entity failed (none with id)')
    if (entity.id === this.world.playerId) return
    entity.destroy()
    this.byId.delete(entity.id)
  }

  removeEditorEntity(entityId) {
    const entity = this.byId.get(entityId)
    if (!entity || entity.id === this.world.playerId) return false
    this.remove(entityId)
    return true
  }

}
